export default "__VITE_ASSET__28b343bd__"